import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ApiResponse, ApiService } from './api.service';
import { Event } from '@models/event.model';
import { StaticContent } from '@models/static-content.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EventService {
    private currentEvent: Event | null = null;

    constructor(
        private apiService: ApiService
    ) {}

    get eventSnapshot() {
        return this.currentEvent;
    }

    getContentByShortCode(code: string): StaticContent | undefined {
      return this.currentEvent?.public_static_content?.find((sc: StaticContent) => sc.short_code === code);
    }

    listEvents(): Observable<ApiResponse<Event[]>> {
      return this.apiService.get<ApiResponse<Event[]>>(`public/platforms/${this.apiService.getPlatformToken}/events`);
    }

    getEventBySlug(slug: string): Observable<ApiResponse<Event>> {
      this.currentEvent = null;
        return this.apiService.get<ApiResponse<Event>>(`public/events/by-slug/${slug}`).pipe(tap({
            next: (response: ApiResponse<Event>) => {
              this.currentEvent = response.data;
            }
          }));
    }
}
